import { render, staticRenderFns } from "./ClientDetailsHeader.vue?vue&type=template&id=0d5881a4&scoped=true"
import script from "./ClientDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ClientDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailsHeader.vue?vue&type=style&index=0&id=0d5881a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5881a4",
  null
  
)

export default component.exports